import React, { Component } from "react";
import dynamic from "next/dynamic";
import CustomLink from "@/bit/components/next13.components.custom-link";
import Text from "@/bit/components/next13.components.text";
import IconGlyph from '@/bit/components/next13.components.icon-glyph'
import { connect } from "react-redux";
import { actions as modalActions } from "@/bit/reducers/next13.reducers.modals-reducer";
const ModalUser = dynamic(() => import("../../../modals/user"));

const getIconSet = (iconId, location) => {
  if (!iconId) return null;

  const iconName = iconId.toLowerCase();
  const isBurgerLocation = location === "burger";

  if (iconName === "tiendas" || iconName === "ayuda" || iconName === "usuario") {
    return (
      <>
        {isBurgerLocation && (
          <>
            <IconGlyph
              className={`${iconName}-m no-hover`}
              color="blue"
              id={`${iconName}-m`}             
              width={24}
              height={24}             
            />
            <IconGlyph
              className={`${iconName}-m hover`}
              color="white"
              id={`${iconName}-m`}
              width={24}
              height={24}
            />
          </>
        )}
        {!isBurgerLocation && (
          <IconGlyph
            className={`${iconName}-m`}
            color="grey6"
            id={`${iconName}-m`}            
            width = {24}
            height = {24}            
          />
        )}
      </>
    );    
  } else {
    return null;
  }
};

class IconsMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpened: false,
    };
  }
  openModal = () => {
    const { addModal, userName, account } = this.props;
    addModal({
      id: "account",
      Element2Show: ModalUser,
      modalProps: {
        contentPosition: "right--top",
        opacityLayoutColor: "blur",
        inSceneEffect: "fadeInTop",
        contentInsideContainer: true,
        outSceneEffect: "fadeOutTop",
        closeAllOnClickOuside: true,
        closeByClickingOutside: true,
        onCloseHandler: this.onCloseHandler,
      },
      elementProps: {
        items: { ...account },
        userName: userName,
        onCloseHandler: this.onCloseHandler,
      },
    });
    this.setState({
      modalOpened: true,
    });
  };

  onCloseHandler = () => {
    this.setState({
      modalOpened: false,
    });
  };

  render() {
    if (!this.props["items"]) {
      return null;
    }
    const items = Object.values(this.props["items"]);
    const { location } = this.props;
    let i = 0;
    return items.map((item) => {
      let link = item.link;

      const iconId = item["icon-id"];
      const text = item.text;
      const cyData = this.props["isModalBurger"]
        ? `Header Burger item ${text}`
        : `Header item ${text}`;
      let _onClick = null;
      if (item["action-id"]) {
        _onClick = this.openModal;
        link = "";
      }
      if (item?.["text"] === "Identifícate"){
        const prefixlink = "https://www.movistar.es/mimovistar-cliente/publico/servicio/login?urlContenedora=https://www.movistar.es/Privada/DesafioUnico&urlDestino=https://www.movistar.es/static/login/authcol%3FurlDestino=";
        _onClick = () => {
          window.location.href = `${prefixlink}${window.location.href}`;
        }
        link = "";
      }
      return (
        <CustomLink
          key={`item-${i++}`}
          href={link}
          onClick={_onClick}
          title={text}
          ariaLabel={text}
          taggingInfo={{
            componentName: "header",
            componentContent: text,
            componentVariation: location,
            componentPerso: "",
            componentProduct: "",
          }}
          cyData={cyData}
        >
          <div className={`menu-item ${iconId}`}>
            <div className="icon-gap">
              {getIconSet(iconId, location)}
            </div>
            <div className="text-gap">
              <Text
                text={text}
                align="center"
                fontType="font-regular"
                size="caption03"
                color="grey6"
                display="block"
              />
            </div>
          </div>
        </CustomLink>
      );
    });
  }
}

const mapStateToProps = (state) => ({
  modals: state.modals.modalHistory,
});

const mapDispatchToProps = (dispatch) => ({
  addModal: (data) => dispatch(modalActions.addModal(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IconsMenu);
